import React from 'react';
import PropTypes from 'prop-types';
import Link from '@ux/link';
import ChevronLeft from '@ux/icon/chevron-left';

import '@ux/icon/chevron-left/styles';

/**
 * Navigation breadcrumb or backlink component
 *
 * @param {Object} props Link data
 * @returns {Link} Rendered breadcrumb or backlink
 * @private
 */

function Breadcrumb({ href, text, eid, onClick }) {
  return (
    <div className='back-link-wrap'>
      <Link
        href={ href }
        data-eid={ eid }
        onClick={ (e) => {
          if (typeof onClick === 'function') {
            e.preventDefault();
            return onClick(e);
          }
        } }
      >
        <ChevronLeft />
        { text }
      </Link>
    </div>
  );
}

Breadcrumb.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  eid: PropTypes.string,
  onClick: PropTypes.func
};

export default Breadcrumb;
